
const formatMessageTime = function (date){
    const now = new Date();
    let isoDate = date.includes('T') ? date : date.replace(' ', 'T') + 'Z';
    let timestamp = new Date(isoDate);

    const isToday = timestamp.getDate() === now.getDate() &&
        timestamp.getMonth() === now.getMonth() &&
        timestamp.getFullYear() === now.getFullYear();
    if (isToday) {
        return timestamp.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    } else {
        return timestamp.toLocaleDateString('pt-BR') + ' ' +
            timestamp.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    }
}

export default formatMessageTime